module.exports = __webpack_public_path__ + "img/V36.8c86cd6e.jpg";